import React, {Component} from 'react';
import {permissionCheck} from "../../../utils";
import {Button, Menu, Dropdown, Icon} from "antd";
import {contentParser} from "../../../base/BaseComponent";

class NormalOperation extends Component {
    render() {
        let {tableComponent, record} = this.props;
        let btns = tableComponent.parseListBtn(record);
        let btnDomList = [];
        btns.forEach((item, index) => {
            if(item.auth){//校验当前用户是否有对应权限，如果有才能看到
                let auth = item.auth;
                if(!permissionCheck(auth)){
                    return;
                }
            }
            if (item.condition.indexOf(record.status) !== -1) {
                btnDomList.push(<Button size={'small'} type="link" key={index} onClick={() => {
                    tableComponent.setState({version: record.version});
                    if(!item.clickParams){

                        item.onOk(record.id, item.name,record)
                    }else{

                        record.self = {...record};
                        let newClickParams = [...item.clickParams];
                        contentParser(newClickParams, {record});
                        contentParser(newClickParams, {item});
                        item.onOk(...newClickParams);
                    }
                }}>{item.name}</Button>)
            }
        });
        return (
            <div className='operation'>
                {
                    btnDomList&&(btnDomList.length > 0)?(
                        btnDomList.map((btn,index)=>{
                            if(index<3) {
                                return btn
                            }
                            if(index===3) {
                                let menus = btnDomList.slice(3,btnDomList.length);
                                menus= (
                                    <Menu>
                                        {
                                            menus.map((menu,Index)=>(
                                                <Menu.Item key={Index}>
                                                    {menu}
                                                </Menu.Item>
                                            ))
                                        }
                                    </Menu>
                                );
                                return (
                                    <Dropdown overlay={menus} placement="bottomLeft" key={index}>
                                        <Icon type="ellipsis" />
                                    </Dropdown>
                                )
                            }
                        })
                    ):"-"
                }
                <style>
                    {`
                        .operation button:first-child {
                            margin-left: -7px
                        }
                    `}
                </style>
            </div>
        )
    }
}

export default NormalOperation;
